import { Button } from '@yellowcard/components-library-vue3';
import { defineComponent, onMounted } from 'vue';
import { useKycStore } from '@/store/modules/kyc';
import { useAuthStore } from '@/store/modules/auth';
import useTransactionsStore from '@/store/modules/transactions';
import { storeToRefs } from 'pinia';
import { KycTypes } from '@/types/kyc';
import { MIXPANEL_EVENTS, trackEvent } from '@/utils/mixpanel';
export default defineComponent({
    name: 'IncompleteKyc',
    props: {},
    components: {
        Button,
    },
    setup() {
        const kycStore = useKycStore();
        const { currentStep } = storeToRefs(kycStore);
        const transactionStore = useTransactionsStore();
        const { showSideMenu } = storeToRefs(transactionStore);
        const authStore = useAuthStore();
        const { partnerId } = storeToRefs(authStore);
        const buttonClicked = () => {
            currentStep.value = KycTypes.KycSteps.KYC_2;
        };
        onMounted(() => {
            trackEvent(MIXPANEL_EVENTS.KYC.SOF, {
                partner: partnerId.value,
            });
        });
        const onKeyPress = () => {
            console.log('key pressed');
        };
        const openSideMenu = () => {
            showSideMenu.value = true;
        };
        return {
            buttonClicked,
            openSideMenu,
            onKeyPress,
        };
    },
});
